require('./events.style.scss');
const { permissions } = require('../../constants/permissions');
const Event = require('../../model/Event');

class EventsController {
    constructor($scope, $filter, $stateParams, $timeout, $rootScope, storageService, crudService, utilsService, eventsPersistence, iamPersistenceService) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.storageService = storageService;
        this.crudService = crudService;
        this.utilsService = utilsService;
        this.iamPersistenceService = iamPersistenceService;
        this.eventsPersistence = eventsPersistence;
        this.selectedEvents = [];
        this.isBackupAdmin = this.utilsService.isBackUpAdmin();
        this.isMini = false;
        this.configEventsTable();
        this.$scope.$on('sub-changed', () => {
            this.getEvents(true, true);
            this.eventsPersistence.initDropdownFilters();
        });
    }

    $onInit() {
        this.filterFlag = 0;
        this.stateParamsFilterInit();
        this.eventsPersistence.initDropdownFilters();
        this.getEvents(null, true);
        this.filterFlag++;

        this.destroyBroadcastCatcher = this.$rootScope.$on("subscriptionChanged", () => {
            this.getEvents(true, true);
        });
    }

    $onDestroy() {
        this.destroyBroadcastCatcher();
    }

    configEventsTable() {
        this.eventsTableConfig = [
            { name: this.$filter('translate')('event.table.header.level'), key: 'severity' },
            { name: this.$filter('translate')('event.table.header.message'), key: 'titleDescription' },
            { name: this.$filter('translate')('event.table.header.category'), key: 'category' },
            { name: this.$filter('translate')('event.table.header.timestamp'), key: 'created' }
        ];
    }


    setGrid(grid, refresh) {
        this.grid = grid;
        this.ctxGridStyleConfig = {
            multiselect: false,
            columnsWidthMapInPct: []
        };
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('7%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('71%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('8%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('14%');
        this.$timeout(() => {
            let user = this.storageService.getUser();
            this.grid.tableName = (refresh ? grid.tableId : this.grid.tableName) + '-' + user.username + '-' + user.userGroupName;
            if (angular.isDefined(this.storageService.getGridWolumnsWidthMapInPct(this.grid.tableName))) {
                this.ctxGridStyleConfig.columnsWidthMapInPct = this.storageService.getGridWolumnsWidthMapInPct(this.grid.tableName);
            }
            this.gridColumnsStyleConfig = this.ctxGridStyleConfig;
            this.gridFlag = true;
        }, 0);
    }

    stateParamsFilterInit() {
        let timeFilter = this.eventsPersistence.filters.filter(item => item.filterKey === Event.getTimeRangeKey())[0];
        if (timeFilter) timeFilter.datetimeLocaleFormat = this.eventsPersistence.datetimeLocaleFormat;


        let stateParam = this.$stateParams.statusFilter;
        let created = this.$stateParams.created;

        if (!stateParam && !created) return;

        this.eventsPersistence.clearFilter();
        let statusFilter = this.eventsPersistence.filters.filter(item => item.filterKey === Event.getSeverityKey())[0];
        statusFilter.setOptionByValue(stateParam);

        if (created) {
            createdFilter = this.eventsPersistence.filters.filter(item => item.filterKey === Event.getTimeRangeKey())[0];
            createdFilter.setOptionByValue(created);
        }
    }

    filterRefresh() {
        this.getEvents(true, null, true);
        this.eventsPersistence.initDropdownFilters();
        this.filterFlag++;
    }

    getEvents(firstPage, firstLoad, clearSelection) {
        this.busy = true;
        if (clearSelection) {
            this.shownDetailsIndex = false;
            this.selectedEvents = [];
        }
        if (firstLoad && this.$stateParams.eventUuid) {
            this.eventsPersistence.clearFilter();
            firstPage = true;
        }
        this.eventsPersistence.get(firstPage, this.eventsPersistence.filters).then(events => {
            this.events = !events ? [] : events;
            this.events.forEach(e => {
                e.created = this.$filter('localizeDate')(e.created, 'shortSec');
            });
            if (firstLoad && this.events.length && this.$stateParams.eventUuid) {
                this.$timeout(() => {
                    this.selectedEvents = this.events.filter(event => {
                        if (event.uuid === this.$stateParams.eventUuid) {
                            event._selected = true;
                            return event;
                        }
                    });
                    this.showDetails(this.selectedEvents[0]);
                });
            }
            else if (this.selectedEvents && this.selectedEvents.length) {
                this.$timeout(() => {
                    this.selectedEvents = this.events.filter(event => event.uuid === this.selectedEvents[0].uuid);
                    if (!this.selectedEvents[0]) {
                        this.shownDetailsIndex = false;
                        return;
                    }
                    this.selectedEvents[0]._selected = true;
                }, 0);
            }
            this.busy = false;
        }, err => {
            this.isMini = false;
            this.busy = false;
            this.events = [];
            this.selectedEvents = [];
            this.shownDetailsIndex = false;
        });
    }

    showDetails(item) {
        this.shownDetailsIndex = item._selected ? item.uuid : false;
        if (this.shownDetailsIndex) {
            this.eventsPersistence.getDetails(this.shownDetailsIndex).then(details => {
                this.setEventDetails(details.data.entities[0]);
            });
        }
    }

    setEventDetails(event) {
        if (!event) return;
        if (event.taskId) {
            this.eventsPersistence.getRelatedTask(event.taskId).then(res => {
                event.relatedTask = res.data.items[0];
                this.setDetails(event);
            }, () => {
                this.setDetails(event);
            });
        } else {
            this.setDetails(event);
        }
    };

    setDetails(event) {
        this.selectedEvent = event;
        this.selectedEvent.name = event.message;
        if (this.selectedEvent.name[this.selectedEvent.name.length - 1] === ".") this.selectedEvent.name = this.selectedEvent.name.slice(0, -1);
        this.eventDetails = [
            {
                detail: this.$filter('translate')('event.subTable.details.uuid.label'),
                value: event.uuid,
                icon: 'icon-copy',
                id: 'event-uuid'
            },
            {
                detail: this.$filter('translate')('event.subTable.details.authorityEmail.label'),
                value: event.user
            },
            {
                detail: this.$filter('translate')('event.subTable.details.relatedTask.label'),
                value: event.relatedTask ? event.relatedTask.label : null,
                goToState: event.relatedTask && event.relatedTask.label ? 'app.jobs' : null,
                stateFilterLabel: 'jobUuid',
                stateFilterName: event.relatedTask && event.relatedTask.label ? event.relatedTask.value : null
            },
            {
                detail: this.$filter('translate')('event.subTable.details.messageLevel.label'),
                value: this.utilsService.enumToNiceString(event.severity),
                severity: event.severity
            },
            {
                detail: this.$filter('translate')('event.subTable.details.authority.label'),
                value: event.authority.identifier,
                authority: event.authority.identifier
            }
            ,
            {
                detail: this.$filter('translate')('event.subTable.details.authorityType.label'),
                value: this.utilsService.enumToNiceString(event.authority.type),
                authority: event.authority.type
            }
        ];
        this.selectedEvent.messageDetailsDescription = event.details ? this.processMessage(event.details) : '';
        this.events.filter(item => {
            if (item.uuid === this.selectedEvent.uuid) item.alreadyRead = true;

        });
    }

    processMessage(message) {
        return message.replace(/(?:\r\n|\r|\n)/g, '<br>');
    }

    onExport(type) {
        this.busy = true;
        return this.eventsPersistence[type === 'all' ? 'getAllEvents' : 'get'](null, this.eventsPersistence.filters, type === 'all', {isExport: true}).then(res => {
            return res.map(item => {
                let result = {};
                result['severity'] = item.severity;
                result['message'] = item.message;
                result['category'] = item.category;
                result['timestamp'] = this.$filter('localizeDate')(item.created, 'shortSec');
                return result;
            });
        }).finally(() => {
            this.busy = false;
        });
    }

    hasEventListingPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.EVENT_LISTING);

    }

    hasEventDetailsPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.EVENT_DETAILS);
    }
}

const eventsComponent = {
    controller: EventsController,
    template: require('./events.template.html')
};

EventsController.$inject = ['$scope', '$filter', '$stateParams', '$timeout', '$rootScope', 'storageService', 'crudService', 'utilsService', 'eventsPersistence', 'iamPersistenceService'];

module.exports = eventsComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/events/events.component.js